import { render, staticRenderFns } from "./ReminderFilter.vue?vue&type=template&id=29e001ed&"
import script from "./ReminderFilter.vue?vue&type=script&lang=js&"
export * from "./ReminderFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports